import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';

Sentry.init({
  dsn: 'https://fb0ad38e363fe3d151a389f66d477bd9@o1147956.ingest.us.sentry.io/4509560889344000',
   integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation: require('react-router-dom').useLocation,
      useNavigationType: require('react-router-dom').useNavigationType,
      createRoutesFromChildren: require('react-router-dom').createRoutesFromChildren,
      matchRoutes: require('react-router-dom').matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);



// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import '././styles/index.scss';
// import App from './App';
// import * as Sentry from "@sentry/react";

// const root = ReactDOM.createRoot(
// 	document.getElementById('root') as HTMLElement
// );
// root.render(
// 	<React.StrictMode>
// 		<App />
// 	</React.StrictMode>
// );


